import React, { useState } from 'react';
import PropTypes from 'prop-types';

const BrandedEnvelope = ({
    envelopesLeft, envelopeLinkToCopy, openEnvelopeBuilder = () => { },
}) => {
    const isSettingsPage = window.location.pathname === '/account/settings/my-portal';
    const [urlCopiedEnvelope, setUrlCopiedEnvelope] = useState(false);
    const copyURL = (link, type) => {
        navigator.clipboard.writeText(link)
            .then(() => {
                if (type === 'envelope') setUrlCopiedEnvelope(true);

                // Reset the urlCopied state after 3000 milliseconds (3 seconds)
                setTimeout(() => {
                    if (type === 'envelope') setUrlCopiedEnvelope(false);
                }, 3000);
            })
            .catch((error) => {
                console.error('Unable to copy to clipboard:', error);
            });
    };

    return (
        <div className='branded-envelope' style={{
            border: '1px solid #C6C6C9',
            margin: '4px 0',
            borderRadius: 5,
        }}>
            <div className='info-section' style={{ padding: 12 }}>
                <h3 className="font-serif margin-t-0px margin-b-4px font-blue-16">Create a Branded Envelope</h3>
                <p className="font-w-3 margin-0px">Leave a lasting impression with a perfectly crafted envelope.</p>
                <p className="font-blue-48 margin-t-8px margin-b-8px">
                    <a href="https://community.thankview.com/t/y4hzs17/how-to-envelope-builder" target="_blank" rel='noreferrer'>
                        Learn about branded envelopes
                    </a>
                </p>
            </div>
            <hr className="margin-0px" style={{ height: '0px' }} />
            <div className='buttons-section' style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
                <button
                    type="button"
                    className={`btn margin-b-16px sm-margin-b-0px width-100 sm-width-auto font-size-14px ${urlCopiedEnvelope ? 'btn--green-97' : 'btn--secondary'}`}
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => copyURL(envelopeLinkToCopy, 'envelope')}
                >
                    <i className="fa fa-link" style={{ fontSize: 'small' }}></i> {urlCopiedEnvelope ? 'Copied!' : 'Copy Shareable Link'}
                </button>
                {
                    envelopesLeft > 0 && <button type="button" className="btn btn--primary-alt btn margin-l-8px margin-b-16px sm-margin-b-0px width-100 sm-width-auto font-size-14px" style={{ whiteSpace: 'nowrap' }} onClick={(event) => openEnvelopeBuilder(event)}><i className="fas fa-envelope" style={{ fontSize: 'small' }}></i> Create Envelope</button>
                }

                {
                    envelopesLeft <= 0 && (
                        <div className="flex width-100 justify-content-space-around">
                            <a href="https://community.thankview.com/t/y4hzs17/how-to-envelope-builder" target="_blank" rel='noreferrer' className="btn btn--primary-alt font-w-8">
                                Get more envelopes
                            </a>

                            {
                                envelopesLeft < 0 && !isSettingsPage && (
                                    <a href="/account/settings/my-portal#myBrandedEnvelopes" className="btn btn--secondary font-w-8">
                                        See your envelopes
                                    </a>
                                )
                            }
                        </div>
                    )
                }
            </div>
        </div>
    );
};

BrandedEnvelope.propTypes = {
    envelopesLeft: PropTypes.number,
    envelopeLinkToCopy: PropTypes.string,
    openEnvelopeBuilder: PropTypes.func,
};

export default BrandedEnvelope;
